import React from "react"
import { Container, Row, Col, Card } from "reactstrap"
import { useLocation } from "react-router-dom"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import RenderSubmenu from "../../components/Common/renderMenu"
import ProjectOverview from "./overview"

const ProjectManagement = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Project Management${companyname ? ` | ${companyname}` : ''}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const location = useLocation()

  const menuItem = loggedUser?.smenu?.find(
    item => item.linkTo === `${location?.pathname}`
  )

  return (
    <div className="page-content page-content-index">
      <ProjectOverview embedded />
      <Container fluid className="">
        <Card className="invoice-main-card">
          <Row className="mt-4 mx-1 mb-3 module-shortcuts">
          {menuItem?.submenus?.map((item, index) => (
              <Col lg={3} sm={4} xs={12} key={item?.id || index}>
                <RenderSubmenu item={item} />
              </Col>
            ))}
            {/* <Col lg={6} sm={6} xs={12}>
              <div className="sub-menu-title mb-3">Masters</div>
              <Row>
                <Col lg={4} sm={6} xs={12}>
                  {menuItem?.submenus?.map(dt => (
                    <>
                      {loggedUser?.permission?.some(
                        permissionItem =>
                          permissionItem?.id === dt.id &&
                          permissionItem?.is_menu == 1 &&
                          permissionItem?.tagline == "Your Shortcuts"
                      ) && (
                        <Link to={dt?.linkTo}>
                          <div className="mb-1">
                          <span className="list-of-dashmenus"><DotIcon /></span>&nbsp;&nbsp;&nbsp;
                            <label className="sub-menu-link" role="button">
                              {dt?.label}
                            </label>
                            <img src={arrow} alt="" width="7" />
                          </div>
                        </Link>
                      )}
                    </>
                  ))}
                </Col>
              </Row>
            </Col>
            <Col lg={6}>
              <div className="sub-menu-title mb-3">Reports</div>
              <Row>
                <Col lg={4} sm={6} xs={12}>
                  {menuItem?.submenus?.map(dt => (
                    <>
                      {loggedUser?.permission?.some(
                        permissionItem =>
                          permissionItem?.id === dt.id &&
                          permissionItem?.is_menu == 1 &&
                          permissionItem?.tagline == "Reports"
                      ) && (
                        <Link to={dt?.linkTo}>
                          <div className="mb-1">
                          <span className="list-of-dashmenus"><DotIcon /></span>&nbsp;&nbsp;&nbsp;
                            <label className="sub-menu-link" role="button">
                              {dt?.label}
                            </label>
                            <img src={arrow} alt="" width="7" />
                          </div>
                        </Link>
                      )}
                    </>
                  ))}
                </Col>
              </Row>
            </Col> */}
          </Row>
        </Card>
      </Container>
    </div>
  )
}

export default ProjectManagement
